import { MenuOption } from "@lexical/react/LexicalTypeaheadMenuPlugin";
import type { BroadcastRange } from "../nodes/broadcast-node";

export class BroadcastTypeaheadOption extends MenuOption {
  range: BroadcastRange;
  display: string;
  constructor(range: BroadcastRange) {
    super(range);
    this.range = range;
    this.display = `@${range}`;
  }
}
